import { deleteDonorAccount, logout } from "appState/auth/authSlice";
import DonateCard from "features/HomePage/components/DonateCard";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const DonorDonations = () => {
  const { projects } = useSelector((state) => state.project);
  const slicedDonateArr = projects?.slice(0, 3);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-6 my-4 items-start">
      <div className="px-12 py-6 bg-white border border-[#838383]">
        <p className="text-[16px] text-[#213874]">Donations</p>
        {false ? (
          <div className="mt-5 flex gap-6 justify-center max-md:flex-wrap">
            {slicedDonateArr?.map((donateCard) => (
              <div key={donateCard.id}>
                <DonateCard
                  id={donateCard.id}
                  cardImage={donateCard.cardImage}
                  title={donateCard.title}
                  body={donateCard.body}
                  amountRaised={donateCard.amountRaised}
                  targetAmount={donateCard.targetAmount}
                  bgColor={donateCard.theme}
                  width={donateCard.width}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="mt-5">
            <p className="text-[#7A7A7A]">
              You have not donated to a project yet. If you would like to
              support a project, explore our projects by theme and location, and
              find the one that speaks to your heart.
            </p>
            <div className="flex justify-center items-center">
              <button
                type="button"
                className="bg-[#213874] my-2 hover:bg-[#11224d] text-white py-2 px-8 rounded-3xl"
              >
                Find a Project
              </button>
            </div>
          </div>
        )}
      </div>
      <div className="w-full flex justify-end items-end">
        <p
          onClick={() => {
            dispatch(deleteDonorAccount()).then((data) => {
              const { payload } = data;
              if (payload?.status === 200) {
                dispatch(logout());
                navigate("/auth/donor/login");
              }
            });
          }}
          className="cursor-pointer py-3 px-8 border hover:bg-[#f4dfdf] text-[#C81818] border-[#C81818]"
        >
          Delete my account
        </p>
      </div>
    </div>
  );
};

export default DonorDonations;
